var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from 'react';
import { EventBusEvent } from '../enums/EventBus';
import EventBus from '../event-bus/EventBus';
import { useKeyboardClose } from './keyboard';
var eventBus = new EventBus();
export var useOpenDisclaimer = function (eventData) {
    return useCallback(function () {
        eventBus.emit(EventBusEvent.ToggleDisclaimer, __assign({ open: true }, eventData));
    }, [eventData]);
};
export var useCloseDrawer = function (toggleEvent) {
    var closeDrawer = useCallback(function () {
        eventBus.emit(toggleEvent, { open: false });
    }, []);
    useKeyboardClose(true, closeDrawer);
    return closeDrawer;
};
